import React, { useEffect } from 'react'
import { Button } from '../Button'
import { Flex } from '../Flex'
import { H4 } from '../Heading'
import { Close } from '../Icon'
import { Line } from '../Line'
import { P } from '../P'
import './confirmation-modal-component.scss'
import { RootState, AppDispatch } from '../../../store'
import { useDispatch, useSelector } from 'react-redux'
import {
  showModelTimeout,
  hideModel,
  confirmActionModel,
} from '../../../global-state/confirm-model-slice'
import { InputModal } from '../InputModal'

function ConfirmationModal() {
  const dispatch = useDispatch<AppDispatch>()
  const { isShow, message, isConfirm, name } = useSelector((state: RootState) => state.confirmModel)
  useEffect(() => {
    if (isConfirm) {
      dispatch(showModelTimeout())
    }
  }, [isConfirm, dispatch])

  return isShow ? (
    <InputModal onBackdropClick={() => dispatch(hideModel())}>
      <Flex variant='column' classes={['input-modal']} dataTestId='confirmation-modal'>
        <Flex variant='space-between'>
          <H4 text={name} />
          <Close
            height='24px'
            classes={['pointer']}
            onClick={() => {
              dispatch(hideModel())
            }}
          />
        </Flex>
        <Line />
        <Flex variant='column' classes={['reply-section']}>
          <P variant='default-gray' text={message} />
          <Line />
          <div className='confirmation-model-button-container'>
            <Button
              variant='secondary-btn'
              text='Cancel'
              handleClick={() => {
                dispatch(hideModel())
              }}
            />
            <Button
              variant='primary-btn'
              text='Confirm'
              handleClick={() => {
                dispatch(confirmActionModel())
              }}
            />
          </div>
        </Flex>
      </Flex>
    </InputModal>
  ) : null
}

export { ConfirmationModal }
